import type {
  TooltipContentProps,
  TooltipProviderProps,
} from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import {
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from "./tooltip-primitives";

type TooltipProps = {
  children: ReactNode;
  className?: string;
  contentProps?: TooltipContentProps;
  providerProps?: Omit<TooltipProviderProps, "children">;
  trigger: ReactNode;
};

const Tooltip = ({
  children,
  className,
  contentProps,
  providerProps,
  trigger,
}: TooltipProps) => {
  return (
    <TooltipProvider {...providerProps}>
      <TooltipRoot>
        <TooltipTrigger asChild={true}>{trigger}</TooltipTrigger>
        <TooltipContent className={className} {...contentProps}>
          {children}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
};

export { Tooltip };
